import React from 'react'
import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'
import { string } from 'prop-types'
import Notice from './Notice'

const cardColors = {
  blue: { background: colors.blue05, text: colors.blue70, scrim: colors.blue90 },
  green: { background: colors.green05, text: colors.green70, scrim: colors.green90 },
  yellow: { background: colors.yellow05, text: colors.yellow70, scrim: colors.yellow90 },
  red: { background: colors.red05, text: colors.red70, scrim: colors.red90 },
  purple: { background: colors.purple05, text: colors.purple70, scrim: colors.purple90 },
}

const titleContainerCss = css`
  position: absolute;
  bottom: 0px;
  inset-inline-start: 0px;
  height: 87px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  padding-top: 12px;
  padding-inline-end: 12px;
  padding-bottom: 27px;
  padding-inline-start: 32px;
`
const subTitleCss = css`
  font-size: 24px;
  color: white;
`

export default function RecommendedCard({
  title = 'TITLE',
  subtitle = 'SUBTITLE',
  notice,
  noticePosition,
  noticeColor,
  color = 'blue',
  img = '',
}) {
  const cardCss = css`
    height: 300px;
    border-radius: 12px;
    background: url(${img}) ${cardColors[color].text} no-repeat center/90%;
    font-family: 'Noto Sans', sans-serif;
    font-weight: 700;
  `
  const overlayCss = css`
    height: 100%;
    width: 100%;
    background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 20%, ${cardColors[color].scrim} 100%);
    border-radius: 12px;
    &:hover {
      background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, black 100%);
    }
  `
  const titleCss = css`
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    opacity: 0.8;
    color: ${cardColors[color].background};
  `

  return (
    <div css={cardCss} data-testid="recommended-card">
      <div css={overlayCss} />
      <Notice text={notice} position={noticePosition} color={noticeColor ?? color} />
      <div css={titleContainerCss}>
        <h5 css={titleCss}>{title}</h5>
        <h5 css={subTitleCss}>{subtitle}</h5>
      </div>
    </div>
  )
}

RecommendedCard.propTypes = {
  title: string,
  subtitle: string,
  color: string,
  img: string,
}
